import { IResourceComponentsProps, useSelect, useTranslate } from '@pankod/refine-core'

import {
  Checkbox,
  CreateButton,
  DateField,
  EditButton,
  FilterDropdown,
  FilterDropdownProps,
  Input,
  List,
  Radio,
  Select,
  ShowButton,
  Space,
  Table,
  Tabs,
  Tag,
  useDrawerForm,
  useModal
} from '@pankod/refine-antd'

import { ExportToExcelButton } from 'components/ExportToExcelButton/ExportToExcelButton'
import { DateFilterDropdown } from 'components/filterDropdown'
import { definitions, Order, Supplement } from 'interfaces'
import { tablePropsProps } from 'pages/ordersLive/ordersLiveList'
import { Fragment, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ClientStatusIdTypes, IssueLocationId, IssueStatusIdTypes, IssueSubTypeIdTypes, IssueTypeIdTypes, ReturnIssueTypeIdTypes } from 'types/types'
import { ALL_CLOSE_ISSUE_ID, CANCELLED_STATUS, capitalizeFirstLetter, CLIENT_ID, DECREASE_RETURN_STATUS, DEFAULT_DATE_FORMAT, DEFAULT_DATE_TIME_FORMAT, DELIVERY_ISSUE_ID, extractMainDomainFromURL, filter, getSupaData, INTERNAL_SPENDING_RETURN_STATUS, ISSUE_TYPE_AFTER_SALE_ID, ISSUE_TYPE_IDS, ISSUE_TYPE_REFUND_CANARY_ID, ISSUE_TYPE_REFUND_MADRID_ID, ISSUE_TYPE_TRANSPORT_ID, MADRID_ID, MapIssuesItemsWithItems, NO_STOCK_STATUS, OF_CANARY_ID, ORDER_STATUS_ID_REQUESTED, PARCIAL_RETURN_STATUS, PENALIZATION_STATUS, PICKUP_ISSUE_ID, PROVIDER_ISSUE_TYPE_IDS, REFUND_ORDER_PROVIDER_LESS_THAN_90_DAYS_TYPE_ID, REFUND_ORDER_PROVIDER_TYPE_ID, RETURN_STATUS, SEND_TO_MADRID_ID, SENT_SUPPLIER_ID, sortAlphabetically, sorter, supabaseClient, updateIssueLocation, WALLAPOP_ISSUE_ID } from 'utility'
import { CLIENT_STATUSES_MAPPER, getConfigForIssueType, ISSUE_LOCATION_MAPPER, ISSUE_STATUS_MAPPER, ISSUE_SUB_TYPES_MAPPER, ISSUE_TYPES_MAPPER } from 'utility/mapper'
import { IssueDrawer } from './drawer'
import { ModalChangeIssuesLocations } from './ModalChangeIssuesLocations'
import { RefundOrderProviderTable } from './refundOrderProviderTable'

type Issues = definitions['issues'] & { 'order_id': definitions['orders'] }

const IssueTable: React.FC<IResourceComponentsProps & { issueTypeId: IssueTypeIdTypes }> = ({ issueTypeId }) => {
  let callingServer = false
  let isOpened

  if (issueTypeId === ALL_CLOSE_ISSUE_ID) {
    isOpened = false
  } else {
    isOpened = true
  }

  let permanentFilter: filter[] = []

  if (!(issueTypeId === WALLAPOP_ISSUE_ID as IssueTypeIdTypes)) {
    permanentFilter = [
      { field: 'deleted', operator: 'eq', value: false },
      { field: 'is_opened', operator: 'eq', value: isOpened },
      { field: 'is_wallapop', operator: 'eq', value: false }
    ]

    if (issueTypeId === PICKUP_ISSUE_ID as IssueTypeIdTypes) {
      permanentFilter.push({ field: 'shipping_method', operator: 'eq', value: 'Recogida' })
      permanentFilter.push({ field: 'issue_type_id', operator: 'in', value: [ISSUE_TYPE_REFUND_MADRID_ID, ISSUE_TYPE_REFUND_CANARY_ID, ISSUE_TYPE_AFTER_SALE_ID, ISSUE_TYPE_TRANSPORT_ID, REFUND_ORDER_PROVIDER_TYPE_ID, REFUND_ORDER_PROVIDER_LESS_THAN_90_DAYS_TYPE_ID, ALL_CLOSE_ISSUE_ID] })
      permanentFilter.push({ field: 'is_completed', operator: 'eq', value: true })
    } else if (issueTypeId === DELIVERY_ISSUE_ID as IssueTypeIdTypes) {
      permanentFilter.push({ field: 'shipping_method', operator: 'eq', value: 'Entrega' })
      permanentFilter.push({ field: 'issue_type_id', operator: 'in', value: [ISSUE_TYPE_REFUND_MADRID_ID, ISSUE_TYPE_REFUND_CANARY_ID, ISSUE_TYPE_AFTER_SALE_ID, ISSUE_TYPE_TRANSPORT_ID, REFUND_ORDER_PROVIDER_TYPE_ID, REFUND_ORDER_PROVIDER_LESS_THAN_90_DAYS_TYPE_ID, ALL_CLOSE_ISSUE_ID] })
      permanentFilter.push({ field: 'is_completed', operator: 'eq', value: true })
    } else {
      permanentFilter.push({ field: 'issue_type_id', operator: issueTypeId !== ALL_CLOSE_ISSUE_ID ? 'eq' : 'in', value: (issueTypeId !== ALL_CLOSE_ISSUE_ID ? issueTypeId : [ISSUE_TYPE_REFUND_MADRID_ID, ISSUE_TYPE_REFUND_CANARY_ID, ISSUE_TYPE_AFTER_SALE_ID, ISSUE_TYPE_TRANSPORT_ID, REFUND_ORDER_PROVIDER_TYPE_ID, REFUND_ORDER_PROVIDER_LESS_THAN_90_DAYS_TYPE_ID, ALL_CLOSE_ISSUE_ID]) })
    }
  } else {
    permanentFilter = [
      { field: 'deleted', operator: 'eq', value: false },
      { field: 'is_wallapop', operator: 'eq', value: true }
    ]
  }

  const [tableProps, setTableProps] = useState<tablePropsProps>({ dataSource: [] })
  const [filters, setFilters] = useState<filter[]>([...permanentFilter])
  const [sorter, setSorter] = useState<sorter>({ field: 'id', ascending: false })
  const [totalData, setTotalData] = useState<number>(0)
  const [currentPage, setCurrentPage] = useState(localStorage.getItem('issuesPage') ? parseInt(localStorage.getItem('issuesPage') || '1') : 1)
  const [pageSize, setPageSize] = useState(localStorage.getItem('issuesPageSize') ? parseInt(localStorage.getItem('issuesPageSize') || '10') : 10)
  const [loading, setLoading] = useState(false)
  const [selectedRows, setSelectedRows] = useState<definitions['issues'][]>([])
  const [editId, setEditId] = useState<number>()

  const [shipperFilter, setShipperFilter] = useState<String>('')
  const [shippingMethodFilter, setShippingMethodFilter] = useState<String>('')
  const [trackingIDFilter, setTrackingIDFilter] = useState<String>('')

  const {
    modalProps: modalPropsChangeIssuesLocationns,
    show: showChangeIssuesLocationns,
    close: closeChangeIssuesLocationns
  } = useModal()

  const getIssuesList = async (resetPages: boolean = false) => {
    if (!callingServer) {
      setLoading(true)
      callingServer = true
      const cPage = (resetPages) ? 1 : currentPage
      const cPageSize = pageSize

      const { data, count } = await getSupaData('issues', '*, order_id!inner(id, items(id, name, url), shipping_address_id(id, street), status!inner(id, name), marketplace_id(id, name), location)', cPage, cPageSize, filters, sorter)

      let filteredData = data
      let counter = count
      if (data && data.length > 0 && [PICKUP_ISSUE_ID, DELIVERY_ISSUE_ID].includes(issueTypeId)) {
        filteredData = data.filter((issue) => {
          if (issue.issue_type_id === ISSUE_TYPE_REFUND_CANARY_ID) {
            if (issue.location === MADRID_ID) return issue
            else return null
          }
          return issue
        })
        counter = filteredData.length
      }

      const tableProps = {
        dataSource: filteredData || []
      }
      setTableProps(tableProps)
      setTotalData(counter || 0)
      setLoading(false)
    }
    setLoading(false)
    callingServer = false
  }

  useEffect(() => {
    // console.log('filters -->', filters)
    if (!callingServer) {
      getIssuesList()
    }
  }, [filters])

  useEffect(() => {
    // console.log('sorter -->', sorter)
    if (!callingServer) {
      if (tableProps.dataSource.length > 0) {
        getIssuesList()
      }
    }
  }, [sorter, currentPage, pageSize])

  const {
    drawerProps: createDrawerProps,
    formProps: createFormProps,
    show: createShow,
    close
  } = useDrawerForm<Issues>({
    action: 'create',
    resource: 'issues',
    redirect: false
  })

  const { options: statusOptions } = useSelect<definitions['status']>({
    resource: 'status',
    optionLabel: 'name',
    optionValue: 'id',
    sort: [
      {
        field: 'id',
        order: 'asc'
      }
    ]
  })

  const { t } = useTranslation()

  const handleCompletedChange = async (value: any, record: any, func?: Function) => {
    if (record.id) {
      await supabaseClient
        .from('issues')
        .update({
          is_completed: value
        })
        .eq('id', record.id)
    }
  }

  const handleEditLocation = async (key: number | null | undefined, issueId: number) => {
    await updateIssueLocation(key, issueId)
    getIssuesList()
  }

  function dataToExport (issues: Issues[]) {
    return issues.map((issue) => {
      const involvedProducts = MapIssuesItemsWithItems(issue).map((item: { name: string }) => item.name)?.join(' | ') || ''
      const issueType = t(`issues.issue_types.${ISSUE_TYPES_MAPPER[issue.issue_type_id as IssueTypeIdTypes]}`)
      const issueSubTypeId = issue.issue_sub_type_id ? t(`issues.issue_sub_types.${issue.issue_sub_type_id ? ISSUE_SUB_TYPES_MAPPER[issue.issue_sub_type_id as IssueSubTypeIdTypes] : ''}`) : ''
      const clientStatus = issue.client_status_id ? t(`issues.client_statuses.${issue.client_status_id ? CLIENT_STATUSES_MAPPER[issue.client_status_id as ClientStatusIdTypes] : ''}`) : ''
      const issueStatus = issue.issue_status_id ? t(`issues.issue_statuses.${issue.issue_status_id ? ISSUE_STATUS_MAPPER[issue.issue_status_id as IssueStatusIdTypes] : ''}`) : ''

      return {
        [t('issues.fields.id')]: issue.id || '',
        [t('issues.fields.order_id')]: issue.order_id || '',
        [t('issues.fields.involved_products')]: involvedProducts,
        [t('issues.fields.issue_type_id')]: issueType,
        [t('issues.fields.issue_sub_type_id')]: issueSubTypeId,
        [t('issues.fields.return_method')]: issue.return_method,
        [t('issues.fields.client_status_id')]: clientStatus,
        [t('issues.fields.issue_status_id')]: issueStatus,
        [t('issues.fields.reason')]: issue.reason || '',
        [t('issues.fields.notes')]: issue.notes || '',
        [t('issues.fields.notes_marketplace')]: issue.notes_marketplace || '',
        [t('issues.fields.request_date')]: issue.request_date ? new Date(issue.request_date) : '',
        [t('issues.fields.shipping_method')]: issue.shipping_method || '',
        [t('issues.fields.shipper')]: issue.shipper || '',
        [t('issues.fields.tracking_id')]: issue.tracking_id || '',
        [t('issues.fields.issue_deadline')]: issue.issue_deadline ? new Date(issue.issue_deadline) : '',
        // [t('issues.fields.delivery_deadline')]: issue.delivery_deadline ? new Date(issue.delivery_deadline) : '',
        [t('issues.fields.created_at')]: new Date(issue.created_at) || '',
        [t('issues.fields.internal')]: issue.internal ? t('issues.fields.internal') : t('issues.fields.client')
      }
    })
  }

  async function exportIssues () {
    return dataToExport(tableProps.dataSource || [])
  }

  const { issueSubTypes, clientStatuses, issueStatuses } = getConfigForIssueType(issueTypeId)
  return (
    <List
      headerProps={{
        extra: <>
          <CreateButton onClick={() => createShow()} />
          <EditButton onClick={showChangeIssuesLocationns}>
            {t('issues.titles.change_location')}
          </EditButton>
          <ExportToExcelButton
            filename={`${t('issues.titles.list')}-${t(`issues.issue_types.${ISSUE_TYPES_MAPPER[issueTypeId]}`)}`}
            asyncFunction={exportIssues}
          />
        </>
      }}
      title={t('issues.titles.list')}
    >
      <Table
        {...tableProps}
        scroll={{ x: '100%', y: '60vh' }}
        rowKey="id"
        loading={loading}
        onRow={(record) => ({
          onClick: (event: any) => {
            setEditId(record.id)
          }
        })}
        pagination={{
          current: currentPage,
          pageSize: pageSize,
          total: totalData,
          onChange (page, pageSize) {
            setCurrentPage(page)
            setPageSize(pageSize)
            localStorage.setItem('issuesPage', page.toString() || '')
            localStorage.setItem('issuesPageSize', pageSize.toString() || '')
          }
        }}
        onChange={(_pagination: any, _filters: any, sorter: any, _extra: any) => {
          if (sorter && sorter.order) {
            setSorter({ field: sorter.field, ascending: (sorter.order === 'ascend') })
          }
          if (_filters) {
            const nextFilter = [...permanentFilter]
            Object.entries(_filters).forEach((entry: any) => {
              if (entry[1] !== null) {
                // nextFilter.push({})
                if (Array.isArray(entry[1])) {
                  nextFilter.push({ field: entry[0], operator: 'in', value: entry[1] })
                } else if (typeof entry[1] === 'string') {
                  nextFilter.push({ field: entry[0], operator: 'eq', value: entry[1] })
                }
              }
            })
            setFilters([...nextFilter])
          }
        }}
        rowSelection={{
          type: 'checkbox',
          onChange: (
            _selectedRowKeys: React.Key[],
            selectedRows: definitions['issues'][]
          ) => {
            setSelectedRows(selectedRows)
          },
          getCheckboxProps: (record: any) => ({
            id: record.id.toString()
          })
        }}
      >
        <Table.Column
          key="id"
          dataIndex="id"
          title="ID"
          width={125}
          align='center'
          sorter
        />
        {![PICKUP_ISSUE_ID, DELIVERY_ISSUE_ID].includes(issueTypeId) &&
          <Table.Column<Issues>
            key="is_opened"
            dataIndex="is_opened"
            align='center'
            title={t('issues.fields.status')}
            sorter
            width={110}
            render={(value: boolean) => (
              <Tag color={value ? 'red' : 'green'}>
                {t(`issues.issue_status.${value ? 'open' : 'close'}`)}
              </Tag>
            )}
            filterDropdown={(props: FilterDropdownProps) => (
              <FilterDropdown
                {...props}
                clearFilters={() => {
                  props.clearFilters?.()
                  props.confirm()
                }}
              >
                <Select
                  placeholder={t('issues.fields.status')}
                  options={[
                    { label: t('issues.issue_status.open'), value: 'true' },
                    { label: t('issues.issue_status.close'), value: 'false' }
                  ]}
                  style={{ minWidth: 100 }}
                />
              </FilterDropdown>
            )}
          />
        }
        <Table.Column<Issues>
          key="created_at"
          dataIndex="created_at"
          align="center"
          title={t('issues.fields.created_at_issue')}
          render={(value) => value && <DateField format={DEFAULT_DATE_TIME_FORMAT} value={value}/>}
          sorter
          width={175}
          filterDropdown={() => (
            <DateFilterDropdown
              field='created_at'
              filters={filters}
              setFilters={(newFilter: any, method: string) => {
                if (newFilter.length > 0 && method === 'merge') {
                  let filtersToAdd = [...filters]
                  if (filters.find((x: filter) => x.field === 'created_at' && x.operator === 'gte')) {
                    const updatedFilters = [...filtersToAdd]
                    const index = updatedFilters.findIndex((x: filter) => x.field === 'created_at' && x.operator === 'gte')
                    updatedFilters[index].value = newFilter[0].value

                    filtersToAdd = [...updatedFilters]
                  } else {
                    filtersToAdd = [...filtersToAdd, ...[newFilter[0]]]
                  }

                  if (filters.find((x: filter) => x.field === 'created_at' && x.operator === 'lte')) {
                    const updatedFilters = [...filtersToAdd]
                    const index = updatedFilters.findIndex((x: filter) => x.field === 'created_at' && x.operator === 'lte')
                    updatedFilters[index].value = newFilter[1].value

                    filtersToAdd = [...updatedFilters]
                  } else {
                    filtersToAdd = [...filtersToAdd, ...[newFilter[1]]]
                  }

                  setFilters([...filtersToAdd])
                } else {
                  setFilters([...filters.filter((x: filter) => x.field !== 'created_at')])
                }
              }}
            />
          )}
        />
        <Table.Column<Issues>
          key="issue_deadline"
          dataIndex="issue_deadline"
          align="center"
          title={t('issues.fields.issue_deadline')}
          render={(value) => value && <DateField format={DEFAULT_DATE_FORMAT} value={value}/>}
          sorter
          width={150}
          filterDropdown={() => (
            <DateFilterDropdown
              field='issue_deadline'
              filters={filters}
              setFilters={(newFilter: any, method: string) => {
                if (newFilter.length > 0 && method === 'merge') {
                  let filtersToAdd = [...filters]
                  if (filters.find((x: filter) => x.field === 'issue_deadline' && x.operator === 'gte')) {
                    const updatedFilters = [...filtersToAdd]
                    const index = updatedFilters.findIndex((x: filter) => x.field === 'issue_deadline' && x.operator === 'gte')
                    updatedFilters[index].value = newFilter[0].value

                    filtersToAdd = [...updatedFilters]
                  } else {
                    filtersToAdd = [...filtersToAdd, ...[newFilter[0]]]
                  }

                  if (filters.find((x: filter) => x.field === 'issue_deadline' && x.operator === 'lte')) {
                    const updatedFilters = [...filtersToAdd]
                    const index = updatedFilters.findIndex((x: filter) => x.field === 'issue_deadline' && x.operator === 'lte')
                    updatedFilters[index].value = newFilter[1].value

                    filtersToAdd = [...updatedFilters]
                  } else {
                    filtersToAdd = [...filtersToAdd, ...[newFilter[1]]]
                  }

                  setFilters([...filtersToAdd])
                } else {
                  setFilters([...filters.filter((x: filter) => x.field !== 'issue_deadline')])
                }
              }}
            />
          )}
        />
        {[ISSUE_TYPE_REFUND_CANARY_ID].includes(issueTypeId) &&
          <Table.Column<Issues>
            key='internal'
            dataIndex="internal"
            align="center"
            title={t('issues.fields.internalBy')}
            width= {135}
            render={(value) => <p>{value ? t('issues.fields.internal') : t('issues.fields.client')}</p>}
            sorter
            filterDropdown={(props: FilterDropdownProps) => (
              <FilterDropdown {...props}>
                <Radio.Group>
                  <Radio value='true'>{t('issues.fields.internal')}</Radio>
                  <Radio value='false'>{t('issues.fields.client')}</Radio>
                </Radio.Group>
              </FilterDropdown>
            )}
          />
        }

        <Table.Column<Issues>
          key="order_id"
          align='center'
          dataIndex={['order_id', 'id']}
          title={t('issues.fields.order_id')}
          sorter
          width={110}
          filterDropdown={(props: FilterDropdownProps) => (
            <FilterDropdown
              {...props}
              clearFilters={() => {
                props.clearFilters?.()
                props.confirm()
              }}
            >
              <Select
                mode="multiple"
                placeholder={t('issues.fields.order_id')}
                showSearch
                defaultActiveFirstOption={false}
                showArrow={true}
                options={(tableProps.dataSource || []).map(issue => ({
                  value: issue.order_id.id.toString(),
                  label: issue.order_id.id.toString()
                }))}
                filterOption={false}
                style={{ minWidth: 160 }}
              />
            </FilterDropdown>
          )}
        />
        {![PICKUP_ISSUE_ID, DELIVERY_ISSUE_ID].includes(issueTypeId) &&
          <Table.Column<Issues>
            key="order_id.status.id"
            dataIndex={['order_id', 'status', 'name']}
            title={t('issues.fields.syniva_status')}
            sorter
            width={120}
            render={(value) => capitalizeFirstLetter(value)}
            filterDropdown={(props: FilterDropdownProps) => (
              <FilterDropdown
                {...props}
                clearFilters={() => {
                  props.clearFilters?.()
                  props.confirm()
                }}
              >
                <Select
                  placeholder={t('issues.fields.syniva_status')}
                  options={statusOptions.map(status => ({
                    value: status.value.toString(),
                    label: capitalizeFirstLetter(status.label)
                  }))}
                  style={{ minWidth: 200 }}
                />
              </FilterDropdown>
            )}
          />
        }
        {issueTypeId === ISSUE_TYPE_REFUND_CANARY_ID &&
          <Table.Column<Issues>
            key="return_method"
            dataIndex="return_method"
            title={t('issues.fields.return_method')}
            sorter
            width={150}
            render={(value: ReturnIssueTypeIdTypes) => value ?? ''}
          />
        }
        {![PICKUP_ISSUE_ID, DELIVERY_ISSUE_ID].includes(issueTypeId) &&
          <Table.Column<Issues>
            key="issue_sub_type_id"
            dataIndex="issue_sub_type_id"
            title={t('issues.fields.issue_sub_type_id')}
            sorter
            width={130}
            render={(value: IssueSubTypeIdTypes) => value ? t(`issues.issue_sub_types.${ISSUE_SUB_TYPES_MAPPER[value]}`) : ''}
            filterDropdown={(props: FilterDropdownProps) => {
              if (!issueSubTypes) return null

              return (
                <FilterDropdown
                  {...props}
                  clearFilters={() => {
                    props.clearFilters?.()
                    props.confirm()
                  }}
                >
                  <Select
                    placeholder={t('issues.fields.issue_sub_type_id')}
                    options={issueSubTypes
                      ? Object.entries(issueSubTypes)
                        .map(([key, value]) => ({
                          value: key,
                          label: t(`issues.issue_sub_types.${value}`)
                        }))
                        .sort((a, b) => sortAlphabetically(a.label, b.label))
                      : []
                    }
                    style={{ minWidth: 200 }}
                  />
                </FilterDropdown>
              )
            }}
          />
        }
        {![PICKUP_ISSUE_ID, DELIVERY_ISSUE_ID].includes(issueTypeId) &&
          <Table.Column<Issues>
            key='is_completed'
            dataIndex="is_completed"
            align="center"
            title={t('issues.fields.is_completed')}
            width= {135}
            render={(value, record: Issues) => (
              <Space style={{ justifyContent: 'center' }}>
                <Checkbox defaultChecked={record.is_completed} onChange={(e: any) => handleCompletedChange(e.target.checked, record)} />
              </Space>
            )}
            sorter
            filterDropdown={(props: FilterDropdownProps) => (
              <FilterDropdown {...props}>
                <Radio.Group>
                  <Radio value='true'>{t('status.yes')}</Radio>
                  <Radio value='false'>{t('status.no')}</Radio>
                </Radio.Group>
              </FilterDropdown>
            )}
          />
        }
        {![PICKUP_ISSUE_ID, DELIVERY_ISSUE_ID].includes(issueTypeId) &&
          <Table.Column<Issues>
            key="client_status_id"
            dataIndex="client_status_id"
            title={t('issues.fields.client_status_id')}
            sorter
            width={150}
            render={(value: ClientStatusIdTypes) => value ? t(`issues.client_statuses.${CLIENT_STATUSES_MAPPER[value]}`) : ''}
            filterDropdown={(props: FilterDropdownProps) => {
              if (!clientStatuses) return null

              return (
                <FilterDropdown
                  {...props}
                  clearFilters={() => {
                    props.clearFilters?.()
                    props.confirm()
                  }}
                >
                  <Select
                    placeholder={t('issues.fields.client_status_id')}
                    options={clientStatuses
                      ? Object.entries(clientStatuses)
                        .map(([key, value]) => ({
                          value: key,
                          label: t(`issues.client_statuses.${value}`)
                        }))
                        .sort((a, b) => sortAlphabetically(a.label, b.label))
                      : []
                    }
                    style={{ minWidth: 200 }}
                  />
                </FilterDropdown>
              )
            }}
          />
        }
        {![PICKUP_ISSUE_ID, DELIVERY_ISSUE_ID].includes(issueTypeId) &&
          <Table.Column<Issues>
            key="location"
            dataIndex="location"
            title={t('issues.fields.location')}
            sorter
            width={220}
            render={(value: IssueLocationId, record, index) => {
              if (editId === record.id) {
                return (
                  <Select
                    style={{ width: 180 }}
                    options={Object.entries(ISSUE_LOCATION_MAPPER).map(([key, value]) => ({
                      value: parseInt(key),
                      label: t(`issues.issue_location.${value}`)
                    }))}
                    defaultValue={value ? t(`issues.issue_location.${ISSUE_LOCATION_MAPPER[value]}`) : undefined}
                    onChange={(key) => handleEditLocation(key, record.id)}
                  />
                )
              }
              const allIssueLocation = [CLIENT_ID, OF_CANARY_ID, SEND_TO_MADRID_ID, MADRID_ID, SENT_SUPPLIER_ID]
              if (allIssueLocation.includes(value)) {
                return t(`issues.issue_location.${ISSUE_LOCATION_MAPPER[value]}`)
              } else {
                return null
              }
            }}
            filterDropdown={(props: FilterDropdownProps) => (
              <FilterDropdown
                {...props}
                clearFilters={() => {
                  props.clearFilters?.()
                  props.confirm()
                }}
              >
                <Select
                    style={{ width: 180 }}
                    options={Object.entries(ISSUE_LOCATION_MAPPER).map(([key, value]) => ({
                      value: key,
                      label: t(`issues.issue_location.${value}`)
                    }))}
                  />
              </FilterDropdown>
            )}
          />
        }
        <Table.Column<Issues>
            align="center"
            title={t('issues.fields.shipping_address')}
            sorter
            width={125}
            key="order_id.location"
            dataIndex={['order_id', 'location']}
            filterDropdown={(props: FilterDropdownProps) => (
              <FilterDropdown
                {...props}
                clearFilters={() => {
                  props.clearFilters?.()
                  props.confirm()
                }}
              >
                <Input type='text' />
              </FilterDropdown>
            )}
        />
        {![PICKUP_ISSUE_ID, DELIVERY_ISSUE_ID].includes(issueTypeId) &&
          <Table.Column<Issues>
            key="issue_status_id"
            dataIndex="issue_status_id"
            title={t('issues.fields.issue_status_id')}
            sorter
            width={170}
            render={(value: IssueStatusIdTypes) => value ? t(`issues.issue_statuses.${ISSUE_STATUS_MAPPER[value]}`) : ''}
            filterDropdown={(props: FilterDropdownProps) => {
              if (!issueStatuses) return null

              return (
                <FilterDropdown
                  {...props}
                  clearFilters={() => {
                    props.clearFilters?.()
                    props.confirm()
                  }}
                >
                  <Select
                    placeholder={t('issues.fields.issue_status_id')}
                    options={issueStatuses
                      ? Object.entries(issueStatuses)
                        .map(([key, value]) => ({
                          value: key,
                          label: t(`issues.issue_statuses.${value}`)
                        }))
                        .sort((a, b) => sortAlphabetically(a.label, b.label))
                      : []
                    }
                    style={{ minWidth: 200 }}
                  />
                </FilterDropdown>
              )
            }}
          />
        }
        {/* {![PICKUP_ISSUE_ID, DELIVERY_ISSUE_ID].includes(issueTypeId) &&
          <Table.Column<Issues>
            key="reason"
            dataIndex="reason"
            title={t('issues.fields.reason')}
            sorter
            width={200}
          />
        } */}
        {![PICKUP_ISSUE_ID, DELIVERY_ISSUE_ID].includes(issueTypeId) &&
          <Table.Column<Issues>
            key="notes"
            dataIndex="notes"
            title={t('issues.fields.notes')}
            sorter
            width={300}
            render={value => <span style={{ whiteSpace: 'pre-line' }}>{value}</span>}
          />
        }
        <Table.Column<Issues>
            align="center"
            title={t('issues.fields.marketplace')}
            sorter
            width={140}
            key="order_id.marketplace_id"
            dataIndex={['order_id', 'marketplace_id', 'name']}
            filterDropdown={(props: FilterDropdownProps) => (
              <FilterDropdown
                {...props}
                clearFilters={() => {
                  props.clearFilters?.()
                  props.confirm()
                }}
              >
                <Select
                  placeholder={t('issues.fields.marketplace')}
                  showSearch
                  defaultActiveFirstOption={false}
                  showArrow={true}
                  options={(tableProps.dataSource || []).map(issue => ({
                    value: issue.order_id.marketplace_id.id.toString(),
                    label: issue.order_id.marketplace_id.name
                  }))}
                  filterOption={false}
                  style={{ minWidth: 160 }}
                />
              </FilterDropdown>
            )}
        />
        {[PICKUP_ISSUE_ID, DELIVERY_ISSUE_ID].includes(issueTypeId) &&
          <Table.Column<Issues>
            align="center"
            dataIndex={['order_id', 'items', 0, 'url']}
            title={t('order.fields.purchaseUrl')}
            width={150}
            render={(value) => {
              const url = extractMainDomainFromURL(value).domain || ''
              return <p> {url} </p>
            }}
          />
        }
        {![PICKUP_ISSUE_ID, DELIVERY_ISSUE_ID].includes(issueTypeId) &&
          <Table.Column<Issues>
            key="notes_marketplace"
            dataIndex="notes_marketplace"
            title={t('issues.fields.notes_marketplace')}
            sorter
            width={150}
            render={value => <span style={{ whiteSpace: 'pre-line' }}>{value}</span>}
          />
        }

        {![PICKUP_ISSUE_ID, DELIVERY_ISSUE_ID].includes(issueTypeId) &&
          <Table.Column<Issues>
            key="request_date"
            dataIndex="request_date"
            align="center"
            title={t('issues.fields.request_date')}
            render={(value) => value && <DateField format={DEFAULT_DATE_TIME_FORMAT} value={value}/>}
            sorter
            width={120}
          />
        }
        <Table.Column<Issues>
          key="created_by"
          dataIndex="created_by"
          title={t('issues.fields.created_by')}
          sorter
          width={300}
          render={(value) => <span style={{ whiteSpace: 'pre-line' }}>{value}</span>}
          filterDropdown={(props: FilterDropdownProps) => (
            <FilterDropdown
              {...props}
              clearFilters={() => {
                props.clearFilters?.()
                props.confirm()
              }}
            >
              <Select
                placeholder={t('order.fields.userEmail')}
                showSearch
                defaultActiveFirstOption={false}
                showArrow={true}
                options={(tableProps.dataSource || []).map(issue => ({
                  value: issue.created_by,
                  label: issue.created_by
                }))}
                filterOption={false}
                style={{ minWidth: 160 }}
              />
            </FilterDropdown>
          )}
        />
        <Table.Column<Issues>
          key="asigned_to"
          dataIndex="asigned_to"
          title={t('issues.fields.asigned_to')}
          sorter
          width={180}
          render={(value) => <span style={{ whiteSpace: 'pre-line' }}>{value}</span>}
          filterDropdown={(props: FilterDropdownProps) => (
            <FilterDropdown
              {...props}
              clearFilters={() => {
                props.clearFilters?.()
                props.confirm()
              }}
            >
              <Select
                placeholder={t('order.fields.userEmail')}
                showSearch
                defaultActiveFirstOption={false}
                showArrow={true}
                options={(tableProps.dataSource || []).map(issue => ({
                  value: issue.asigned_to,
                  label: issue.asigned_to
                }))}
                filterOption={false}
                style={{ minWidth: 160 }}
              />
            </FilterDropdown>
          )}
        />
        {![PICKUP_ISSUE_ID, DELIVERY_ISSUE_ID].includes(issueTypeId) &&
          <Table.Column<Issues>
            key="shipping_method"
            dataIndex="shipping_method"
            title={t('issues.fields.shipping_method')}
            sorter
            width={110}
            filtered={filters.find((f: filter) => f.field === 'shipping_method') !== undefined}
            filterDropdown={(props) => (
              <FilterDropdown {...props}
                mapValue={(selectedKeys) => {
                  setShippingMethodFilter(selectedKeys.toString())
                  return selectedKeys.toString()
                }}
                clearFilters={() => {
                  setFilters([...filters.filter((x: filter) => x.field !== 'shipping_method')])
                  setShippingMethodFilter('')
                }}
                confirm={() => {
                  if (shippingMethodFilter) {
                    if (filters.find((x: filter) => x.field === 'shipping_method')) {
                      const updatedFilters = [...filters]
                      const index = updatedFilters.findIndex((x: filter) => x.field === 'shipping_method')
                      updatedFilters[index].value = shippingMethodFilter

                      setFilters([...updatedFilters])
                    } else {
                      setFilters([...filters, ...[{ field: 'shipping_method', operator: 'ilike', value: shippingMethodFilter }]])
                    }
                  }
                }}
              >
                <Input type='text' />
              </FilterDropdown>
            )}
          />
        }
        <Table.Column<Issues>
          key="shipper"
          dataIndex="shipper"
          title={t('issues.fields.shipper')}
          sorter
          width={150}
          filtered={filters.find((f: filter) => f.field === 'shipper') !== undefined}
          filterDropdown={(props) => (
            <FilterDropdown {...props}
              mapValue={(selectedKeys) => {
                setShipperFilter(selectedKeys.toString())
                return selectedKeys.toString()
              }}
              clearFilters={() => {
                setFilters([...filters.filter((x: filter) => x.field !== 'shipper')])
                setShipperFilter('')
              }}
              confirm={() => {
                if (shipperFilter) {
                  if (filters.find((x: filter) => x.field === 'shipper')) {
                    const updatedFilters = [...filters]
                    const index = updatedFilters.findIndex((x: filter) => x.field === 'shipper')
                    updatedFilters[index].value = shipperFilter

                    setFilters([...updatedFilters])
                  } else {
                    setFilters([...filters, ...[{ field: 'shipper', operator: 'ilike', value: shipperFilter }]])
                  }
                }
              }}
            >
              <Input type='text' />
            </FilterDropdown>
          )}
        />
        <Table.Column<Issues>
          key="tracking_id"
          dataIndex="tracking_id"
          title={t('issues.fields.tracking_id')}
          sorter
          width={150}
          filtered={filters.find((f: filter) => f.field === 'tracking_id') !== undefined}
          filterDropdown={(props) => (
            <FilterDropdown {...props}
              mapValue={(selectedKeys) => {
                setTrackingIDFilter(selectedKeys.toString())
                return selectedKeys.toString()
              }}
              clearFilters={() => {
                setFilters([...filters.filter((x: filter) => x.field !== 'tracking_id')])
                setTrackingIDFilter('')
              }}
              confirm={() => {
                if (trackingIDFilter) {
                  if (filters.find((x: filter) => x.field === 'tracking_id')) {
                    const updatedFilters = [...filters]
                    const index = updatedFilters.findIndex((x: filter) => x.field === 'tracking_id')
                    updatedFilters[index].value = trackingIDFilter

                    setFilters([...updatedFilters])
                  } else {
                    setFilters([...filters, ...[{ field: 'tracking_id', operator: 'ilike', value: trackingIDFilter }]])
                  }
                }
              }}
            >
              <Input type='text' />
            </FilterDropdown>
          )}
        />
        {/* {![PICKUP_ISSUE_ID, DELIVERY_ISSUE_ID].includes(issueTypeId) &&
          <Table.Column<Issues>
            key="delivery_deadline"
            dataIndex="delivery_deadline"
            align="center"
            title={t('issues.fields.delivery_deadline')}
            render={(value) => value && <DateField format={DEFAULT_DATE_FORMAT} value={value}/>}
            sorter
            width={110}
          />
        }        */}
        <Table.Column<Issues>
          fixed="right"
          title={t('table.actions')}
          dataIndex="actions"
          key="actions"
          align="center"
          width={150}
          render={(_, record) => {
            return (
              <ShowButton
                resourceNameOrRouteName='issues'
                hideText
                style={{ color: 'green', fontSize: '15px' }}
                recordItemId={record.id}
              />
            )
          }}
        />
      </Table>

      <ModalChangeIssuesLocations
        modalProps={modalPropsChangeIssuesLocationns}
        close={closeChangeIssuesLocationns}
        selectedRows={selectedRows}
        getIssuesList={() => getIssuesList()}
      />

      <IssueDrawer
        drawerProps={createDrawerProps}
        formProps={createFormProps}
        close={close}
        refetchFn={() => getIssuesList()}
        issueTypeId={issueTypeId}
      />
    </List>
  )
}

export const IssueList: React.FC<IResourceComponentsProps> = () => {
  const t = useTranslate()
  const select = 'id, estimated_costs_status, alias, total, is_priority, completed, created_at, processed_at, estimated_delivered_date, package_number, location, cancelation_date, initial_payment, return_date, locked, locked_by, status_id, sequra_disbursement_ref, issue_comments, issue_reviewed_at, status(id, name), payment_method_id(id, name), marketplace_id(id, name), custom_marketplace_id(original_url), supplements(supplement, volumetric, description, status(id, name))'

  const dataToExport = (orders: any[], issueTypeId?: number) => {
    return orders?.map((order: any) => {
      const marketplace = order?.marketplace_id?.id > 0
        ? order?.marketplace_id?.name
        : order?.marketplace_id?.id === 0
          ? order?.custom_marketplace_id?.original_url || ''
          : (order?.items && order?.items[0]?.custom_order_site) ? order?.items[0]?.custom_order_site : (order?.marketplace_id?.name || '')

      const supplementAmount = (order.supplements && order.supplements.length > 0)
        ? order?.supplements
          .map((s: Supplement) => s.supplement || 0)
          .reduce((a: number, b: number) => a + b, 0)
        : 0

      const billingAmount = (order.refunds && order.refunds.length > 0)
        ? order?.refunds
          .filter((x: any) => !x.deleted && x.type === 'supplier' && x.status_id !== null && (typeof x.status_id === 'object' ? x.status_id?.id : x.status_id) <= ORDER_STATUS_ID_REQUESTED)
          .map((x: any) => x.amount || 0)
          .reduce((a: number, b: number) => a + b, 0)
        : 0

      const auditDeadline = order?.processed_at
        ? (() => {
            const date = new Date(order.processed_at)
            date.setDate(date.getDate() + 99)
            return date.toISOString()
          })()
        : null

      const dataEntryList: [string, any][] = [
        [t('order.fields.id'), order?.id || ''],
        [t('order.fields.alias'), order?.alias || '']
      ]

      if (issueTypeId !== REFUND_ORDER_PROVIDER_TYPE_ID) {
        dataEntryList.push([t('order.fields.package_number'), order?.package_number || ''])
        dataEntryList.push([t('order.fields.location'), order?.location || ''])
        dataEntryList.push([t('order.fields.createdAt'), order?.created_at ? new Date(order?.created_at) : ''])
      } else {
        dataEntryList.push([t('order.fields.issue_comments'), order?.issue_comments || ''])
        dataEntryList.push([t('order.fields.reviewedDate'), order?.issue_reviewed_at ? new Date(order?.issue_reviewed_at) : ''])
        dataEntryList.push([t('issues.fields.issue_state'), (() => {
          const issue = order?.issues?.find((i: any) => i.issue_type_id === issueTypeId)
          return issue ? t(`issues.issue_status.${issue.is_opened ? 'open_f' : 'close_f'}`) : ''
        })()])
        dataEntryList.push([t('order.fields.processed_date'), order?.processed_at ? new Date(order?.processed_at) : ''])
      }

      dataEntryList.push([t('order.fields.auditDate'), auditDeadline ? new Date(auditDeadline) : ''])
      dataEntryList.push([t('order.fields.marketplace'), marketplace || ''])
      dataEntryList.push([t('order.fields.paymentMethod'), order?.payment_method_id?.name || ''])
      dataEntryList.push([t('order.fields.billingAmount'), billingAmount])

      const refundsSupplier = (order.refunds && order.refunds.length > 0)
        ? order?.refunds
          .filter((r: any) => r.type === 'supplier')
          .map((r: any) => r.amount || 0)
          .reduce((a: number, b: number) => a + b, 0)
        : 0

      const supplierRefunds = (order.refunds && order.refunds.length > 0)
        ? order?.refunds.filter((r: any) => r.type === 'supplier' && !r.deleted && r.status_id !== null)
        : []

      const refundWithLowestStatus = supplierRefunds.length > 0
        ? supplierRefunds.reduce((lowest: any, r: any) => {
          const rStatusId = typeof r.status_id === 'object' ? r.status_id?.id : r.status_id
          const lowestStatusId = typeof lowest.status_id === 'object' ? lowest.status_id?.id : lowest.status_id
          return rStatusId < lowestStatusId ? r : lowest
        })
        : null

      const refundStatusId = refundWithLowestStatus
        ? (typeof refundWithLowestStatus.status_id === 'object' ? refundWithLowestStatus.status_id?.id : refundWithLowestStatus.status_id)
        : null

      dataEntryList.push([t('order.fields.refundStatus'), (refundStatusId !== null && refundStatusId !== undefined) ? t(`order.status.${refundStatusId}`) : ''])
      dataEntryList.push([t('order.fields.orderStatus'), capitalizeFirstLetter(order?.status?.name) || ''])
      if (issueTypeId !== REFUND_ORDER_PROVIDER_TYPE_ID) {
        dataEntryList.push([t('order.fields.supplementShipment'), supplementAmount || 0])
        dataEntryList.push([t('order.fields.refundsSupplier'), refundsSupplier || 0])
      }

      const data: any = Object.fromEntries(dataEntryList)

      return data
    })
  }
  const getConditionalClassName = (record: Order) => {
    if (record.cancelation_date && (record.status_id !== CANCELLED_STATUS && record.status_id !== PENALIZATION_STATUS && record.status_id !== NO_STOCK_STATUS)) {
      return 'cancelled-order'
    }
    if (record.return_date && record.status_id !== RETURN_STATUS && record.status_id !== PARCIAL_RETURN_STATUS && record.status_id !== DECREASE_RETURN_STATUS && record.status_id !== INTERNAL_SPENDING_RETURN_STATUS) {
      return 'return-order'
    }
    return ''
  }

  const providerMadridStatusIds = [CANCELLED_STATUS, PENALIZATION_STATUS, NO_STOCK_STATUS]

  const handleShowTables = (issueTypeId: any, statusFilter?: filter) => {
    if (PROVIDER_ISSUE_TYPE_IDS.includes(issueTypeId)) {
      return <RefundOrderProviderTable select={select} dataToExport={dataToExport} getConditionalClassName={getConditionalClassName} issueTypeId={issueTypeId} statusFilter={statusFilter} />
    } else {
      return <IssueTable issueTypeId={issueTypeId} />
    }
  }

  return (
    <Tabs defaultActiveKey="0" size='middle'>
      {ISSUE_TYPE_IDS.map((issueTypeId, index) => {
        if (issueTypeId === REFUND_ORDER_PROVIDER_TYPE_ID) {
          return (
            <Fragment key={index}>
              <Tabs.TabPane tab={t('issues.issue_types.refundsOrdersProviderMadrid')} key={`${index}-madrid`}>
                {handleShowTables(issueTypeId, { field: 'status_id', operator: 'in', value: providerMadridStatusIds })}
              </Tabs.TabPane>
              <Tabs.TabPane tab={t('issues.issue_types.refundsOrdersProviderCanary')} key={`${index}-canary`}>
                {handleShowTables(issueTypeId, { field: 'status_id', operator: 'notin', value: providerMadridStatusIds })}
              </Tabs.TabPane>
            </Fragment>
          )
        }
        return (
          <Tabs.TabPane tab={t(`issues.issue_types.${ISSUE_TYPES_MAPPER[issueTypeId]}`)} key={index} >
            {handleShowTables(issueTypeId)}
          </Tabs.TabPane>
        )
      })}
      <Tabs.TabPane tab={t('issues.issue_types.pickup')} key={9} >
        {handleShowTables(9)}
      </Tabs.TabPane>
      <Tabs.TabPane tab={t('issues.issue_types.delivery')} key={10} >
        {handleShowTables(10)}
      </Tabs.TabPane>
      <Tabs.TabPane tab={t('issues.issue_types.wallapop')} key={11} >
        {handleShowTables(11)}
      </Tabs.TabPane>
    </Tabs>
  )
}
